<template>
  <div class="aframe-360-viewer">
    <v-dialog v-model="dialog" persistent width="600px">
      <v-card>
        <v-card-title v-if="getPracticeExercisePdf() !== ''">
          <span class="headline">      
      {{ getTranslation(
        'Exercícios',
        'Ejercicios')
      }} {{ getPracticeIntroTitle() }}</span>
        </v-card-title>
        <v-card-title v-else>
          <span class="headline">
      {{ getTranslation(
        'Esta prática não possui exercícios!',
        '¡Esta práctica no tiene ejercicios!')
      }}
        </span>
        </v-card-title>
        <v-card-text>
          {{ getPracticeExerciseText() }}
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="getPracticeExercisePdf()" color="primary" text :href="getPracticeExercisePdf()">
      {{ getTranslation(
        'Baixar arquivo',
        'Descargar archivo')
      }}
          </v-btn>
          <v-spacer />
          <v-btn color="primary" text @click="dialog = false, $emit('nextStep', '6')">
      {{ getTranslation(
        'Fim',
        'Fin')
      }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Const from '@/helpers/const'
let json = require('../../json/pratica-' + Const.PRACTICE_NUMBER + '.json')
export default {
  data() {
    return {
      dialog: 'true',
      json: json
    }
  },

  methods: {
    getPracticeIntroTitle() {
      const pratica = this.json.pratica[0]
      return pratica.introducao.titulo
    },

    getPracticeExerciseText() {
      const pratica = this.json.pratica[0]
      return pratica.exercicios.texto
    },

    getPracticeExercisePdf() {
      const pratica = this.json.pratica[0]
      return pratica.exercicios.pdf
    },
    getTranslation(elementPortuguese, elementSpanish) {
      if (Const.PRACTICE_NUMBER.includes('es')) {
        return elementSpanish
      }
      return elementPortuguese
    }
  }
}
</script>

<style scoped>
.aframe-360-viewer {
  background-color: #ffffff;
  overflow: hidden;
  height: 100vh;
  width: 100vw;
}
</style>
